import React from 'react';
import { Box, IconButton } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import TwitterIcon from 'src/assets/images/socialIcon/website/twitter.svg';
import YoutubeIcon from 'src/assets/images/socialIcon/website/youtube.svg';
import FbIcon from 'src/assets/images/socialIcon/website/fb.svg';
import InstaIcon from 'src/assets/images/socialIcon/website/instagram.svg';
import LinkedinIcon from 'src/assets/images/socialIcon/website/linkedin.png';
import TiktokIcon from 'src/assets/images/socialIcon/website/tiktok.png';
import TelegramIcon from 'src/assets/images/socialIcon/website/telegram.png';
import SnapchatIcon from 'src/assets/images/socialIcon/website/snapchat.png';


const useStyles = makeStyles(theme=> ({
  iconBtn:{
    width:'auto',
    height:'auto',

    '& img':{
      width:'100%',
      height:'100%',
    }
  },

  mainDiv:{
    display:'flex',
    flexDirection:'row',
    alignItems:'center',
    flexWrap:'wrap',
    [theme.breakpoints.down('md')]:{
      justifyContent: 'center',
    }
  }
}));

const SocialIcons = ({
  facebookLink,
  instagramLink,
  twitterLink,
  youtubeLink,
  linkedinLink,
  tiktokLink,
  telegramLink,
  snapchatLink,
  color,
  bgcolor,
  border,
  ...props
}) => {

  const classes = useStyles();
  return (
    <Box className={classes.mainDiv} {...props}>
      {facebookLink && (
        <IconButton
          size="small"
          onClick={() => window.open(facebookLink,'_blank')}
          style={{margin:'0px 5px'}}
        >
          <div className={classes.iconBtn}>
            <img src={FbIcon} alt="facebook" />
          </div>
        </IconButton>
      )}

      {instagramLink && (
        <IconButton
          size="small"
          onClick={() => window.open(instagramLink,'_blank')}
          style={{margin:'0px 5px'}}
        >
          <div className={classes.iconBtn}>
            <img src={InstaIcon} alt="Instagram" />
          </div>
        </IconButton>
      )}

      {linkedinLink && (
        <IconButton
          size="small"
          onClick={() => window.open(linkedinLink,'_blank')}
          style={{margin:'0px 5px'}}
        >
          <div className={classes.iconBtn}>
            <img src={LinkedinIcon} alt="Linkedin" />
          </div>
        </IconButton>
      )}

      {tiktokLink && (
        <IconButton
          size="small"
          onClick={() => window.open(tiktokLink,'_blank')}
          style={{margin:'0px 5px'}}
        >
          <div className={classes.iconBtn}>
            <img src={TiktokIcon} alt="Tiktok" />
          </div>
        </IconButton>
      )}

      {telegramLink && (
        <IconButton
          size="small"
          onClick={() => window.open(telegramLink,'_blank')}
          style={{margin:'0px 5px'}}
        >
          <img src={TelegramIcon} alt="Telegram" />
        </IconButton>
      )}

      {youtubeLink && (
        <IconButton
          size="small"
          onClick={() => window.open(youtubeLink,'_blank')}
          style={{margin:'0px 5px'}}
        >
          <div className={classes.iconBtn}>
            <img src={YoutubeIcon} alt="youtube" />
          </div>
        </IconButton>
      )}

      {snapchatLink && (
        <IconButton
          size="small"
          onClick={() => window.open(snapchatLink,'_blank')}
          style={{margin:'0px 5px'}}
        >
          <div className={classes.iconBtn}>
            <img src={SnapchatIcon} alt="snapchat" />
          </div>
        </IconButton>
      )}

      {twitterLink && (
        <IconButton
          size="small"
          onClick={() => window.open(twitterLink,'_blank')}
          style={{margin:'0px 5px'}}
        >
          <div className={classes.iconBtn}>
            <img src={TwitterIcon} alt="Twitter" />
          </div>
        </IconButton>
      )}
    </Box>
  );
};

export default SocialIcons;
